import {
  McleodCommodityOption,
  McleodReferenceNumberOption,
  ValueLabelOption,
} from 'pages/QuoteView/LoadBuilding/McleodSectionForms/types';

export const jrcTransportTypeOptions: ValueLabelOption[] = [
  { value: 'ANY', label: 'ANY - Any Equipment (TS)' },
  { value: 'AC', label: 'AC - Auto Carrier (DAT)' },
  { value: 'DEAM', label: 'DEAM - Beam' },
  { value: 'CN', label: 'CN - Conestoga (DAT)' },
  { value: 'CONG', label: 'CONG - Conestoga (TS)' },
  { value: 'C', label: 'C - Container (DAT)' },
  { value: 'CR', label: 'CR - Container Refrigerated (DAT)' },
  { value: 'CI', label: 'CI - Container, Insulated (DAT)' },
  { value: 'CV', label: 'CV - Conveyor (DAT)' },
  { value: 'DD', label: 'DD - Double Drop (DAT)' },
  { value: 'LA', label: 'LA - Drop Deck, Landoll (DAT)' },
  { value: 'DT', label: 'DT - Dump Trailer (DAT)' },
  { value: 'FLAT', label: 'FLAT - flat' },
  { value: 'FR', label: 'FR - Flat/Van/Reefer (DAT)' },
  { value: 'F', label: 'F - Flatbed (DAT)' },
  { value: 'FA', label: 'FA - Flatbed Airride (DAT)' },
  { value: 'BT', label: 'BT - Flatbed B-Train (DAT)' },
  { value: 'FN', label: 'FN - Flatbed Conestoga (DAT)' },
  { value: 'FZ', label: 'FZ - Flatbed Hazmat (DAT)' },
  { value: 'FH', label: 'FH - Flatbed Hotshot (DAT)' },
  { value: 'MX', label: 'MX - Flatbed Maxi (DAT)' },
  { value: 'FD', label: 'FD - Flatbed or Step Deck (DAT)' },
  { value: 'FO', label: 'FO - Flatbed Over-dimension' },
  { value: 'FM', label: 'FM - Flatbed w/ Team (DAT)' },
  { value: 'FT', label: 'FT - Flatbed w/Traps (DAT)' },
  { value: 'FC', label: 'FC - Flatbed with chains (DAT)' },
  { value: 'HB', label: 'HB - Hopper Bottom (DAT)' },
  { value: 'IR', label: 'IR - Insulated Van or Reefer (DAT)' },
  { value: 'LB', label: 'LB - Lowboy (DAT)' },
  { value: 'LR', label: 'LR - Lowboy or RGN (DAT)' },
  { value: 'LO', label: 'LO - Lowboy Overdimension (DAT)' },
  { value: 'MV', label: 'MV - Moving Van (DAT)' },
  { value: 'NU', label: 'NU - Pneumatic (DAT)' },
  { value: 'PO', label: 'PO - Power Only (DAT)' },
  { value: 'R', label: 'R - Reefer (DAT)' },
  { value: 'RA', label: 'RA - Reefer Airride (DAT)' },
  { value: 'R2', label: 'R2 - Reefer Doubles (DAT)' },
  { value: 'RZ', label: 'RZ - Reefer Hazmat (DAT)' },
  { value: 'RN', label: 'RN - Reefer Intermodal (DAT)' },
  { value: 'RL', label: 'RL - Reefer Logistics (DAT)' },
  { value: 'RV', label: 'RV - Reefer or Vented Van' },
  { value: 'RP', label: 'RP - Reefer Pallet Exchange (DAT)' },
  { value: 'RM', label: 'RM - Reefer w/ Team (DAT)' },
  { value: 'RG', label: 'RG - Removable GooseNeck (DAT)' },
  { value: 'SD', label: 'SD - Step Deck (DAT)' },
  { value: 'SR', label: 'SR - Step Deck or RGN' },
  { value: 'SN', label: 'SN - Stepdeck Conestoga (DAT)' },
  { value: 'SB', label: 'SB - Straight Box Truck' },
  { value: 'ST', label: 'ST - Strectch Trailer (DAT)' },
  { value: 'TA', label: 'TA - Tanker Aluminum (DAT)' },
  { value: 'TN', label: 'TN - Tanker Intermodal (DAT)' },
  { value: 'TS', label: 'TS - Tanker Steel (DAT)' },
  { value: 'TT', label: 'TT - Truck and Trailer (DAT)' },
  { value: 'V', label: 'V - Van (DAT)' },
  { value: 'VA', label: 'VA - Van Airride (DAT)' },
  { value: 'VW', label: 'VW - Van Blanket Wrap' },
  { value: 'VS', label: 'VS - Van Conestoga (DAT)' },
  { value: 'VC', label: 'VC - Van Curtain (DAT)' },
  { value: 'V2', label: 'V2 - Van Double (DAT)' },
  { value: 'VZ', label: 'VZ - Van Hazmat (DAT)' },
  { value: 'VH', label: 'VH - Van Hotshot (DAT)' },
  { value: 'VI', label: 'VI - Van Insulated (DAT)' },
  { value: 'VN', label: 'VN - Van Intermodal (DAT)' },
  { value: 'VG', label: 'VG - Van Lift-Gate (DAT)' },
  { value: 'VL', label: 'VL - Van Logistics (DAT)' },
  { value: 'VF', label: 'VF - Van or Flatbed (DAT)' },
  { value: 'VT', label: 'VT - Van or Flats w/Tarps (DAT)' },
  { value: 'VR', label: 'VR - Van or Reefer (DAT)' },
  { value: 'VP', label: 'VP - Van Pallet Exchange (DAT)' },
  { value: 'VB', label: 'VB - Van Roller Bed (DAT)' },
  { value: 'VV', label: 'VV - Van Vented (DAT)' },
  { value: 'VM', label: 'VM - Van w/ Team (DAT)' },
];

export const jrcRevenueCodes: ValueLabelOption[] = [
  { value: '6A', label: '6A - BRONX' },
  { value: '17A', label: '17A - BRONX LUIS M' },
  { value: '11A', label: '11A - CANALS BRONX' },
  { value: '7A', label: '7A - CAPE COD MA' },
  { value: 'CT', label: 'CT - CT SALES' },
  { value: 'UTA', label: 'UTA - DAVE CT OFFICE' },
  { value: 'UTB', label: 'UTB - DAVE CT OFFICE' },
  { value: 'OONC', label: 'OONC - DELETE' },
  { value: 'SAA', label: 'SAA - delete' },
  { value: 'J6A', label: 'J6A - DOVER DE OFFICE' },
  { value: 'J6B', label: 'J6B - DOVER DE OFFICE' },
  { value: 'ED9A', label: 'ED9A - ED R PALMER' },
  { value: 'OH1A', label: 'OH1A - GROVE CITY OH' },
  { value: 'OH1B', label: 'OH1B - GROVE CITY OH' },
  { value: 'N6A', label: 'N6A - JRC OF FOR MYER' },
  { value: '5B', label: '5B - JRC OF LI' },
  { value: 'N6B', label: 'N6B - JRC OF PAY VEHI' },
  { value: 'OR', label: 'OR - OR BROKERAGE SA' },
  { value: 'J7A', label: 'J7A - OWNER OPALLENTO' },
  { value: '14A', label: '14A - PALMER EDISON' },
  { value: '14B', label: '14B - PALMER EDISON' },
  { value: '9A', label: '9A - PALMER INTER JR' },
  { value: '16A', label: '16A - PALMER MA' },
  { value: '15A', label: '15A - PALMER SAL' },
  { value: 'SC9A', label: 'SC9A - SALE PALMER SCT' },
  { value: 'SB', label: 'SB - Sales Broker' },
  { value: 'S6B', label: 'S6B - Sales Broker' },
  { value: 'S8B', label: 'S8B - Sales Broker' },
  { value: 'P2B', label: 'P2B - Sales Broker' },
  { value: 'PB', label: 'PB - Sales Broker' },
  { value: 'RRB', label: 'RRB - Sales Broker' },
  { value: 'S5B', label: 'S5B - Sales Broker' },
  { value: 'OSB', label: 'OSB - Sales Broker' },
  { value: 'N5B', label: 'N5B - Sales Broker' },
  { value: 'NCB', label: 'NCB - Sales Broker' },
  { value: 'N3B', label: 'N3B - Sales Broker' },
  { value: 'N4B', label: 'N4B - Sales Broker' },
  { value: 'W2B', label: 'W2B - Sales Broker' },
  { value: 'W4B', label: 'W4B - Sales Broker' },
  { value: 'W5B', label: 'W5B - Sales Broker' },
  { value: 'W6B', label: 'W6B - Sales Broker' },
  { value: 'W8B', label: 'W8B - Sales Broker' },
  { value: 'WB', label: 'WB - Sales Broker' },
  { value: 'TXB', label: 'TXB - Sales Broker' },
  { value: 'WPB', label: 'WPB - Sales Broker' },
  { value: 'WYB', label: 'WYB - Sales Broker' },
  { value: 'ALB', label: 'ALB - Sales Broker' },
  { value: 'B3B', label: 'B3B - Sales Broker' },
  { value: 'B4B', label: 'B4B - Sales Broker' },
  { value: 'B5B', label: 'B5B - Sales Broker' },
  { value: 'B6B', label: 'B6B - Sales Broker' },
  { value: 'B7B', label: 'B7B - Sales Broker' },
  { value: 'B8B', label: 'B8B - Sales Broker' },
  { value: 'BB', label: 'BB - Sales Broker' },
  { value: 'C5B', label: 'C5B - Sales Broker' },
  { value: 'C7B', label: 'C7B - Sales Broker' },
  { value: 'J2B', label: 'J2B - Sales Broker' },
  { value: 'J3B', label: 'J3B - Sales Broker' },
  { value: 'J4B', label: 'J4B - Sales Broker' },
  { value: 'J5B', label: 'J5B - Sales Broker' },
  { value: 'M1B', label: 'M1B - Sales Broker' },
  { value: 'MCB', label: 'MCB - Sales Broker' },
  { value: 'CSB', label: 'CSB - Sales Broker' },
  { value: 'EB', label: 'EB - Sales Broker' },
  { value: 'D2B', label: 'D2B - Sales Broker' },
  { value: 'F1B', label: 'F1B - Sales Broker' },
  { value: 'FCS', label: 'FCS - Sales Broker' },
  { value: 'G4B', label: 'G4B - Sales Broker' },
  { value: 'INB', label: 'INB - Sales Broker' },
  { value: 'J7B', label: 'J7B - SALES BROKER AL' },
  { value: 'OHB', label: 'OHB - SALES BROKERAGE' },
  { value: 'OO', label: 'OO - Sales Owner Op' },
  { value: 'OHA', label: 'OHA - SALES OWNER OP' },
  { value: 'P2A', label: 'P2A - Sales Owner Op' },
  { value: 'OSA', label: 'OSA - Sales Owner Op' },
  { value: 'N5A', label: 'N5A - Sales Owner Op' },
  { value: 'N4A', label: 'N4A - Sales Owner Op' },
  { value: 'NCA', label: 'NCA - Sales Owner Op' },
  { value: 'S6A', label: 'S6A - Sales Owner Op' },
  { value: 'S5A', label: 'S5A - Sales Owner Op' },
  { value: 'RRA', label: 'RRA - Sales Owner Op' },
  { value: 'PA', label: 'PA - Sales Owner Op' },
  { value: 'SA', label: 'SA - Sales Owner Op' },
  { value: 'S8A', label: 'S8A - Sales Owner Op' },
  { value: 'TXA', label: 'TXA - Sales Owner Op' },
  { value: 'WYA', label: 'WYA - Sales Owner Op' },
  { value: 'WPA', label: 'WPA - Sales Owner Op' },
  { value: 'WA', label: 'WA - Sales Owner Op' },
  { value: 'W8A', label: 'W8A - Sales Owner Op' },
  { value: 'W6A', label: 'W6A - Sales Owner Op' },
  { value: 'W5A', label: 'W5A - Sales Owner Op' },
  { value: 'W4A', label: 'W4A - Sales Owner Op' },
  { value: 'W2A', label: 'W2A - Sales Owner Op' },
  { value: 'J4A', label: 'J4A - Sales Owner Op' },
  { value: 'J3A', label: 'J3A - Sales Owner Op' },
  { value: 'N3A', label: 'N3A - Sales Owner Op' },
  { value: 'MCA', label: 'MCA - Sales Owner Op' },
  { value: 'M1A', label: 'M1A - Sales Owner Op' },
  { value: 'J5A', label: 'J5A - Sales Owner Op' },
  { value: 'J2A', label: 'J2A - Sales Owner Op' },
  { value: 'INA', label: 'INA - Sales Owner Op' },
  { value: 'FCSA', label: 'FCSA - Sales Owner Op' },
  { value: 'G4A', label: 'G4A - Sales Owner Op' },
  { value: 'EA', label: 'EA - Sales Owner Op' },
  { value: 'D2A', label: 'D2A - Sales Owner Op' },
  { value: 'F1A', label: 'F1A - Sales Owner Op' },
  { value: 'C7A', label: 'C7A - Sales Owner Op' },
  { value: 'C5A', label: 'C5A - Sales Owner Op' },
  { value: 'BA', label: 'BA - Sales Owner Op' },
  { value: 'B8A', label: 'B8A - Sales Owner Op' },
  { value: 'B7A', label: 'B7A - Sales Owner Op' },
  { value: 'B6A', label: 'B6A - Sales Owner Op' },
  { value: 'B5A', label: 'B5A - Sales Owner Op' },
  { value: 'B4A', label: 'B4A - Sales Owner Op' },
  { value: 'B3A', label: 'B3A - Sales Owner Op' },
  { value: 'ALA', label: 'ALA - Sales Owner Op' },
  { value: 'KEV9A', label: 'KEV9A - Sales Palmer KO' },
  { value: 'CSA', label: 'CSA - Sales Syracuse' },
  { value: '3A', label: '3A - WAREHAM SUZANNE' },
  { value: 'WCA', label: 'WCA - WESLEY CHAPEL F' },
  { value: 'WCB', label: 'WCB - WESLEY CHAPEL F' },
];

export const jrcOrderTypes: ValueLabelOption[] = [
  { value: 'B', label: 'B - BROKERED LOAD' },
  { value: 'PARTIAL', label: 'PARTIAL - PARTIAL SHIPMENT' },
  { value: 'TL', label: 'TL - Truck Load' },
];

export const jrcCommodityOptions: McleodCommodityOption[] = [
  { code: '29300', description: 'advertsing, flyers', hazmat: 'N', un: '' },
  { code: '15930', description: 'Agglomerated Coal', hazmat: 'N', un: '' },
  { code: '12012', description: 'Agriculteral Limestone', hazmat: 'N', un: '' },
  {
    code: '34920',
    description: 'Agricultural and forestry machinery',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34410',
    description: 'Air conditioning equipment',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34320',
    description: 'Air or vacuum pumps and gas compressors',
    hazmat: 'N',
    un: '',
  },
  {
    code: '37210',
    description: 'Aircraft- excluding parts',
    hazmat: 'N',
    un: '',
  },
  { code: '32400', description: 'Aluminum', hazmat: 'N', un: '' },
  {
    code: '32422',
    description: 'Aluminum bar,rods profiles and wire',
    hazmat: 'N',
    un: '',
  },
  {
    code: '32423',
    description: 'Aluminum Plates,sheet,strip,foil',
    hazmat: 'N',
    un: '',
  },
  { code: '04000', description: 'Animal Feed', hazmat: 'N', un: '' },
  {
    code: '22010',
    description: 'Animal or Vegetable Fertilizer',
    hazmat: 'N',
    un: '',
  },
  { code: '03324', description: 'Apples', hazmat: 'N', un: '' },
  {
    code: '36391',
    description: 'Armored fighting vehicles and parts',
    hazmat: 'N',
    un: '',
  },
  { code: '31921', description: 'asphalt shingles', hazmat: 'N', un: '' },
  {
    code: '36101',
    description: 'Automobiles, small vans, military jeeps',
    hazmat: 'N',
    un: '',
  },
  {
    code: '06410',
    description: 'Baked snack foods, pretzels,tortia chips',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34971',
    description: 'Ball and roller bearings',
    hazmat: 'N',
    un: '',
  },
  { code: '02902', description: 'Barley', hazmat: 'N', un: '' },
  {
    code: '34221',
    description: 'Boilers, power, heating, nuclear reactors',
    hazmat: 'N',
    un: '',
  },
  {
    code: '31911',
    description: 'Buiding Granite and articles',
    hazmat: 'N',
    un: '',
  },
  {
    code: '31951',
    description: 'building block, brick,cement,concrete,artificial stone',
    hazmat: 'N',
    un: '',
  },
  { code: 'BUILD', description: 'Building Products', hazmat: 'N', un: '' },
  { code: '31900', description: 'Building Stone', hazmat: 'N', un: '' },
  { code: '30321', description: 'Carpets', hazmat: 'N', un: '' },
  { code: '31000', description: 'Cement', hazmat: 'N', un: '' },
  { code: '02000', description: 'Cereal Grains', hazmat: 'N', un: '' },
  {
    code: '36340',
    description: 'Chassis fitted with engines for motor vehicles',
    hazmat: 'N',
    un: '',
  },
  {
    code: '10010',
    description: 'Clacreous monumental or building stone',
    hazmat: 'N',
    un: '',
  },
  {
    code: '37320',
    description: 'Commercial ships, boats, and other floating structures',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34910',
    description: 'Commercial washing and packing machinery',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34422',
    description: 'Commercial/industrial refrigerating/freezing equipment',
    hazmat: 'N',
    un: '',
  },
  { code: '35510', description: 'Computer equipment', hazmat: 'N', un: '' },
  { code: '31952', description: 'concrete pipes', hazmat: 'N', un: '' },
  {
    code: '36330',
    description: 'Cranes, drilling, concrete mixers, fire fighting vehicles',
    hazmat: 'N',
    un: '',
  },
  { code: '13300', description: 'dolomite', hazmat: 'N', un: '' },
  {
    code: '35110',
    description: 'Electric motors and generators',
    hazmat: 'N',
    un: '',
  },
  { code: '35120', description: 'Electric transformers', hazmat: 'N', un: '' },
  {
    code: '34120',
    description: 'Engines- Diesel and Semi-Diesel',
    hazmat: 'N',
    un: '',
  },
  {
    code: '28092',
    description: 'envelopes, letter cards,post cards',
    hazmat: 'N',
    un: '',
  },
  { code: 'EQUIPMENT', description: 'Equipment', hazmat: 'N', un: '' },
  {
    code: '27312',
    description: 'facial or toilet tissue',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34330',
    description: 'Fans and ventilating or recycling hoods with a fan',
    hazmat: 'N',
    un: '',
  },
  {
    code: '36310',
    description: 'Farm, lawn, and track-laying tractors',
    hazmat: 'N',
    un: '',
  },
  { code: '22000', description: 'Fertilizer', hazmat: 'N', un: '' },
  {
    code: '32200',
    description: 'flat-rolled iron or steel, strip,rolls,flat',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34511',
    description: 'Forklifts of various design',
    hazmat: 'N',
    un: '',
  },
  { code: 'FAK', description: 'freight of all kind', hazmat: 'N', un: '' },
  { code: '31300', description: 'Glass', hazmat: 'N', un: '' },
  {
    code: '31320',
    description: 'glass containers for packaging,bottles,jars,lids',
    hazmat: 'N',
    un: '',
  },
  { code: '13992', description: 'Gypsum and anhydrite', hazmat: 'N', un: '' },
  { code: '31931', description: 'Gypsum wallboard', hazmat: 'N', un: '' },
  {
    code: '43993',
    description: 'Hardware or plumbing supplies',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34421',
    description: 'Household refrigerating/freezing equipment',
    hazmat: 'N',
    un: '',
  },
  { code: '31100', description: 'hydrolic cements', hazmat: 'N', un: '' },
  {
    code: '39030',
    description: 'Illuminates signs, lamps, lighting, name plates',
    hazmat: 'N',
    un: '',
  },
  {
    code: '35994',
    description: 'Insulated electric conductors- wire, cables',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34110',
    description: 'Internal Combustion Engine Exceeding 1000 cc',
    hazmat: 'N',
    un: '',
  },
  {
    code: '354130',
    description: 'Internal Combustion Piston Engine Parts',
    hazmat: 'N',
    un: '',
  },
  {
    code: '06299',
    description: 'inulin,wheat gluten,milled cereals',
    hazmat: 'N',
    un: '',
  },
  {
    code: '33121',
    description: 'iron and steel fittings',
    hazmat: 'N',
    un: '',
  },
  {
    code: '33111',
    description: 'Iron and Steel pipe and tube',
    hazmat: 'N',
    un: '',
  },
  { code: '14100', description: 'Iron ores', hazmat: 'N', un: '' },
  {
    code: '43991',
    description: 'Items for grocery and convenience stores- includes food',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34520',
    description: 'Land excavating equipment',
    hazmat: 'N',
    un: '',
  },
  { code: '12000', description: 'Lime Products', hazmat: 'N', un: '' },
  {
    code: '03601',
    description: 'Live trees, Bulbs,Roots',
    hazmat: 'N',
    un: '',
  },
  { code: '25020', description: 'logs for lumber', hazmat: 'N', un: '' },
  { code: '25010', description: 'logs for pulping', hazmat: 'N', un: '' },
  { code: '25000', description: 'Lumber', hazmat: 'N', un: '' },
  {
    code: '34000',
    description: 'Machinery equipment, motors, engines',
    hazmat: 'N',
    un: '',
  },
  {
    code: '39011',
    description: 'Mattresses and Mattress Supports',
    hazmat: 'N',
    un: '',
  },
  { code: '03323', description: 'Melons', hazmat: 'N', un: '' },
  {
    code: '33992',
    description: 'metal containers in excess of 80 gallons, gases',
    hazmat: 'N',
    un: '',
  },
  {
    code: '33910',
    description: 'metal containers less than 80 gallons not gases',
    hazmat: 'N',
    un: '',
  },
  {
    code: '33201',
    description: 'metal doors and windows',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34940',
    description: 'Metal-working machine tools',
    hazmat: 'N',
    un: '',
  },
  {
    code: '06100',
    description: 'Milled or otherwise worked grain,wheat,groats,meal',
    hazmat: 'N',
    un: '',
  },
  { code: '43999', description: 'Miscellaneous', hazmat: 'N', un: '' },
  {
    code: '10020',
    description: 'Monumental or building stone',
    hazmat: 'N',
    un: '',
  },
  {
    code: '31942',
    description: 'Mortors and concrete, Dry',
    hazmat: 'N',
    un: '',
  },
  {
    code: '36320',
    description: 'Motor vehicles for 10 or more people',
    hazmat: 'N',
    un: '',
  },
  {
    code: '36210',
    description: 'Motor vehicles for transporting goods',
    hazmat: 'N',
    un: '',
  },
  { code: '36351', description: 'Motorcycles', hazmat: 'N', un: '' },
  {
    code: '33310',
    description: 'nails,screws,bolts and similar',
    hazmat: 'N',
    un: '',
  },
  { code: '29210', description: 'newspaper', hazmat: 'N', un: '' },
  { code: '22020', description: 'Nitrogenous Fertilizer', hazmat: 'N', un: '' },
  { code: '03341', description: 'Nuts in shell', hazmat: 'N', un: '' },
  { code: '02903', description: 'Oats', hazmat: 'N', un: '' },
  { code: '35520', description: 'Office equipment', hazmat: 'N', un: '' },
  { code: '03212', description: 'Onions', hazmat: 'N', un: '' },
  { code: '03311', description: 'Oranges', hazmat: 'N', un: '' },
  {
    code: '03999',
    description: 'Other agricultural, cotton linters,seaweed,forestry prd',
    hazmat: 'N',
    un: '',
  },
  { code: '02909', description: 'Other Cereal Grains', hazmat: 'N', un: '' },
  {
    code: '22090',
    description: 'Other fertilizers for retail sale',
    hazmat: 'N',
    un: '',
  },
  {
    code: '39029',
    description: 'Other furniture not elsewhere classified',
    hazmat: 'N',
    un: '',
  },
  {
    code: '12019',
    description: 'Other gravel and crushed limestone',
    hazmat: 'N',
    un: '',
  },
  {
    code: '12020',
    description: 'other gravel and crushed stone other than lime prods',
    hazmat: 'N',
    un: '',
  },
  {
    code: '39019',
    description: 'Other household or office furniture',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34519',
    description: 'Other lifting, handling, loading, machinery',
    hazmat: 'N',
    un: '',
  },
  {
    code: '36409',
    description: 'Other motor vehicle parts',
    hazmat: 'N',
    un: '',
  },
  {
    code: '36109',
    description: 'Other motor vehicles for fewer than 10 people',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34222',
    description: 'Other non-electric engines and motors',
    hazmat: 'N',
    un: '',
  },
  { code: '24229', description: 'other plastic items', hazmat: 'N', un: '' },
  { code: '25093', description: 'other rough cut wood', hazmat: 'N', un: '' },
  { code: '24399', description: 'Other rubber products', hazmat: 'N', un: '' },
  { code: '13109', description: 'other salt, rock salt', hazmat: 'N', un: '' },
  {
    code: '36399',
    description: 'Other vehicles- snowmobiles, golf carts, etc.',
    hazmat: 'N',
    un: '',
  },
  {
    code: '26909',
    description: 'Other wood including MDF',
    hazmat: 'N',
    un: '',
  },
  {
    code: '26901',
    description: 'pallets,cable drums,barrels',
    hazmat: 'N',
    un: '',
  },
  {
    code: '27200',
    description: 'Paper Large rolls,sheets',
    hazmat: 'N',
    un: '',
  },
  { code: '27000', description: 'Paper Products', hazmat: 'N', un: '' },
  { code: '34991', description: 'Paper-making machinery', hazmat: 'N', un: '' },
  {
    code: '26320',
    description: 'particle board, fiberboard and other similar',
    hazmat: 'N',
    un: '',
  },
  {
    code: '37230',
    description: 'Parts of aircraft and spacecraft',
    hazmat: 'N',
    un: '',
  },
  {
    code: '37103',
    description: 'Parts of locomotives and rolling stock',
    hazmat: 'N',
    un: '',
  },
  { code: '03501', description: 'Peanuts unroasted', hazmat: 'N', un: '' },
  {
    code: '24224',
    description: 'Plastic closures,bottle,food related, bags,pails',
    hazmat: 'N',
    un: '',
  },
  {
    code: '24222',
    description: 'Plastic floors, wall coverings',
    hazmat: 'N',
    un: '',
  },
  {
    code: '24225',
    description: 'Plastic household items',
    hazmat: 'N',
    un: '',
  },
  {
    code: '24223',
    description: 'Plastic tubs,bathtubs,wash basins, toilet seats',
    hazmat: 'N',
    un: '',
  },
  { code: '24000', description: 'Plastics', hazmat: 'N', un: '' },
  {
    code: '24213',
    description: 'Plastics Plates film foil tape strips flat stock',
    hazmat: 'N',
    un: '',
  },
  {
    code: '24221',
    description: 'Plastics tubes,pipes, fittings',
    hazmat: 'N',
    un: '',
  },
  {
    code: '37310',
    description: 'Pleasure/sporting vessels and rowing boats',
    hazmat: 'N',
    un: '',
  },
  { code: '26000', description: 'Plywood', hazmat: 'N', un: '' },
  { code: '07221', description: 'Potato chips', hazmat: 'N', un: '' },
  { code: '03100', description: 'Potatoes', hazmat: 'N', un: '' },
  {
    code: '34950',
    description: 'Powered hand tools- lawn and construction use',
    hazmat: 'N',
    un: '',
  },
  {
    code: '31953',
    description: 'prefab structural concrete',
    hazmat: 'N',
    un: '',
  },
  {
    code: '40920',
    description: 'Prefabricated buildings- tool and garden sheds, etc.',
    hazmat: 'N',
    un: '',
  },
  {
    code: '29100',
    description: 'printed materials, excluding advertising',
    hazmat: 'N',
    un: '',
  },
  { code: '34992', description: 'Printing machinery', hazmat: 'N', un: '' },
  {
    code: '34310',
    description: 'Pumps for liquids and liquid elevators',
    hazmat: 'N',
    un: '',
  },
  {
    code: '33991',
    description: 'rail track construction materiels of Iron and steel',
    hazmat: 'N',
    un: '',
  },
  {
    code: '37101',
    description: 'Railway locomotives and self-propelled rolling-stock',
    hazmat: 'N',
    un: '',
  },
  {
    code: '37102',
    description: 'Railway maintenance vehicles, passenger and freight cars',
    hazmat: 'N',
    un: '',
  },
  {
    code: '31210',
    description: 'refractory materials,mortors and mixes',
    hazmat: 'N',
    un: '',
  },
  {
    code: '36220',
    description: 'Road tractors for semi-trailers',
    hazmat: 'N',
    un: '',
  },
  { code: '36403', description: 'Road wheels', hazmat: 'N', un: '' },
  { code: '24310', description: 'Rubber Tires,flaps', hazmat: 'N', un: '' },
  {
    code: '24391',
    description: 'Rubber Tubes,pipes,hoses',
    hazmat: 'N',
    un: '',
  },
  { code: '13000', description: 'Salt', hazmat: 'N', un: '' },
  { code: '11000', description: 'Sand', hazmat: 'N', un: '' },
  {
    code: '34995',
    description: 'Semiconductor manufacturing machinery',
    hazmat: 'N',
    un: '',
  },
  { code: '03342', description: 'Shelled nuts', hazmat: 'N', un: '' },
  {
    code: '11020',
    description: 'Silica Sand for building',
    hazmat: 'N',
    un: '',
  },
  {
    code: '11010',
    description: 'Silica sands for construction',
    hazmat: 'N',
    un: '',
  },
  { code: '06000', description: 'Snack Foods', hazmat: 'N', un: '' },
  {
    code: '37220',
    description: 'Spacecraft- excluding parts',
    hazmat: 'N',
    un: '',
  },
  { code: '40220', description: 'Sporting equipment', hazmat: 'N', un: '' },
  {
    code: '34211',
    description: 'Steam, Vapor, and Hydraulic Turbines',
    hazmat: 'N',
    un: '',
  },
  { code: '32000', description: 'Steel', hazmat: 'N', un: '' },
  {
    code: '32300',
    description: 'steel bar,rod,shapes and wire',
    hazmat: 'N',
    un: '',
  },
  {
    code: '10000',
    description: 'Stone Building Materials',
    hazmat: 'N',
    un: '',
  },
  {
    code: '43992',
    description: 'Supplies and food for restaurants',
    hazmat: 'N',
    un: '',
  },
  { code: '13101', description: 'table salt', hazmat: 'N', un: '' },
  { code: 'HAZMAT', description: 'TEST HAZMAT', hazmat: 'Y', un: '3159' },
  {
    code: '34930',
    description: 'Textile and laundry machines',
    hazmat: 'N',
    un: '',
  },
  {
    code: '30200',
    description: 'textile clothing and accesories',
    hazmat: 'N',
    un: '',
  },
  {
    code: '30330',
    description: 'textile household items',
    hazmat: 'N',
    un: '',
  },
  {
    code: '28010',
    description: 'toilet paper,facial tissue,sanitary naps for retail',
    hazmat: 'N',
    un: '',
  },
  {
    code: '37104',
    description: 'Track fixtures, signaling, safety, traffic control parts',
    hazmat: 'N',
    un: '',
  },
  {
    code: '36360',
    description: 'Trailers, semi-trailers, and parts',
    hazmat: 'N',
    un: '',
  },
  {
    code: '34972',
    description: 'Transmission shafts and bearing housings',
    hazmat: 'N',
    un: '',
  },
  { code: '26211', description: 'treated lumber', hazmat: 'N', un: '' },
  { code: '25092', description: 'treated wood', hazmat: 'N', un: '' },
  { code: '03600', description: 'Trees and Plants', hazmat: 'N', un: '' },
  {
    code: '34212',
    description: 'Turbo-Jets, Turbo-Propellers, and Gas Turbines',
    hazmat: 'N',
    un: '',
  },
  {
    code: '03991',
    description: 'Unprocessed Coffee or tea',
    hazmat: 'N',
    un: '',
  },
  { code: '26212', description: 'untreated lumber', hazmat: 'N', un: '' },
  {
    code: '26330',
    description: 'vennered panels,plywood,',
    hazmat: 'N',
    un: '',
  },
  {
    code: '41120',
    description: 'Waste and scrap of ferrous metals',
    hazmat: 'N',
    un: '',
  },
  {
    code: '41291',
    description: 'Waste and scrap of glass',
    hazmat: 'N',
    un: '',
  },
  {
    code: '41220',
    description: 'Waste and scrap of paper or paperboard',
    hazmat: 'N',
    un: '',
  },
  { code: '34960', description: 'Welding machinery', hazmat: 'N', un: '' },
  { code: '02100', description: 'wheat', hazmat: 'N', un: '' },
  {
    code: '26401',
    description: 'wood doors,windows,thresholds',
    hazmat: 'N',
    un: '',
  },
  { code: '26222', description: 'wood shingles', hazmat: 'N', un: '' },
  { code: '26310', description: 'wood veneered plywood', hazmat: 'N', un: '' },
  {
    code: '40995',
    description: 'Works of art, collections, antiques',
    hazmat: 'N',
    un: '',
  },
];

export const jrcReferenceNumberOptions: McleodReferenceNumberOption[] = [
  { description: 'Bill of Lading Number', code: 'BM' },
  { description: "Carrier's Reference Number (PRO/Invoice)", code: 'CN' },
  { description: 'Class Code', code: 'ACD' },
  { description: 'Condition of Sale Document Number', code: 'CS' },
  { description: "Consignee's Order Number", code: 'CG' },
  { description: 'Customer Order Number', code: 'CO' },
  { description: 'Customer Reference Number', code: 'CR' },
  { description: 'Dealer Order Number', code: 'ON' },
  { description: 'Delivery Order Number', code: 'DO' },
  { description: 'Depositor Number', code: 'DE' },
  { description: 'Draft Number', code: 'DN' },
  { description: 'Government Bill of Lading', code: 'BL' },
  { description: 'Insurance Certificate Number', code: 'ID' },
  { description: 'Internal Customer Number', code: 'IT' },
  { description: 'Internal Order Number', code: 'IL' },
  { description: 'Line Quanitity', code: 'QL' },
  { description: 'Master Bill of Lading', code: 'MB' },
  { description: 'Multiple P.O.s of an Invoice', code: 'MP' },
  { description: 'Mutally Defined', code: 'ZZ' },
  { description: 'Order Number', code: 'OR' },
  { description: 'Original Invoice Number', code: 'OI' },
  { description: 'Pickset Number', code: 'PS' },
  { description: 'Pickup Number', code: 'PU' },
  { description: 'Purchase Order Number', code: 'PO' },
  { description: 'Rate code number', code: 'RB' },
  { description: 'Seal Number', code: 'SN' },
  { description: 'Serial Number', code: 'SE' },
  { description: "Shipper's Identifying Number (SID)", code: 'SI' },
  { description: "Shipper's Order (Invoice Number)", code: 'SO' },
  { description: 'Standard Carrier Alpha Code (SCAC)', code: 'SCA' },
  { description: 'Transportation Account Code (TAC)', code: 'TH' },
  { description: 'Volume Number', code: 'VD' },
];
